const messages = {
  instrumental: '楽曲に歌詞がない場合にチェックします。',
  featuring_artists: `楽曲にフィーチャリングアーティストが含まれている場合は「有」を選択します。<br>
    入力されたフィーチャリングアーティストは副題としてJASRACのデータベース（J-WID）へ登録されます。<br>
    J-WIDは<a href="https://www2.jasrac.or.jp/eJwid/" target="_blank">こちら</a><br>
    例：Dream (feat. 田中 花子)<br>
    正題： Dream<br>
    副題： Dream (feat. 田中 花子)<br>
  `,
  release_date: `作品を最初に発売した年月日を入力します。<br>
    CD・レコード等で発売している場合は、その発売日を入力します。<br>
    楽曲配信をしている場合は、配信開始日を入力します。<br>
    ※ 配信開始日はnarasuでは確認いただけません。各ストアでご確認ください。
  `,
  authors: `作詞者・作曲者の情報を正しく入力します。<br>
    著作者が複数含まれる場合は「著作者を追加」から入力します。<br>
    著作者情報が正しく入力されなかった場合、著作権使用料の徴収・分配が適切になされない場合があります。`,
  is_group: `バンドやユニットなど、著作者を団体・グループ名義で登録する場合にチェックします。<br>
    グループの場合には、グループ名を著作者公表名として入力し、各メンバーの実名を追加します。`,
  author_name_ja: `楽曲のリリース情報などで公表されている著作者名を入力します。<br>
    JASRACのデータベース（J-WID）に著作者名として表示されます。`,
  is_owner: `著作者がアカウント管理者と同一人物の場合チェックを入れます。<br>
    著作者がアカウント管理者ではない場合、著作権譲渡に係る利用規約の同意メールを送信するためのメールアドレスの入力が必須となります。`,
  co_composer: '作曲に対して補助的な役割で著作に加わった場合、チェックを入れます。',
  co_lyricist: '作詞に対して補助的な役割で著作に加わった場合、チェックを入れます。',
}
export default messages
